import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

type ViewFieldProps = {
  label: ReactNode
  value?: string | number | null
  className?: string
  children?: ReactNode
  showChevron?: boolean
}

export const ViewField = ({
  label,
  value,
  className = "",
  children,
  showChevron = false,
}: ViewFieldProps) => (
  <div className={`flex flex-col bg-neutral-op-8 px-4 py-2.5 rounded-md min-h-[64px] justify-center ${className}`}>
    <span className="text-[12px] text-gray-400 font-medium mb-1">{label}</span>
    <div className="text-[15px] font-semibold text-white flex items-center justify-between">
      <div className="flex items-center gap-2">{children ? children : value || "--"}</div>
      {showChevron && <ChevronDown size={18} className="text-gray-400" />}
    </div>
  </div>
)

